import { Component, Input } from '@angular/core';


export class BsCurrentDateViewComponent {
   title: string;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'bs-current-date',
  template: `<div class="current-timedate"><span>{{ title }}</span></div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../.tmp/datepicker/themes/bs/bs-current-date-view.component.ts